"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REPLACE_VTO_WF_DATA_TEST_IDS = void 0;
var REPLACE_VTO_WF_DATA_TEST_IDS;
(function (REPLACE_VTO_WF_DATA_TEST_IDS) {
    REPLACE_VTO_WF_DATA_TEST_IDS["REPLACE_VTO_WORKFLOW"] = "ReplaceVTOWorkflow";
    REPLACE_VTO_WF_DATA_TEST_IDS["REPLACE_VTO_WORKFLOW_SUMMARY"] = "ReplaceVTOWorkflowSummary";
    REPLACE_VTO_WF_DATA_TEST_IDS["REPLACE_VTO_FINAL_WARNING"] = "ReplaceVTOFinalWarning";
    REPLACE_VTO_WF_DATA_TEST_IDS["REPLACE_VTO_WF_VTO_SUMMARY"] = "ReplaceVTOWFVTOSummary";
})(REPLACE_VTO_WF_DATA_TEST_IDS = exports.REPLACE_VTO_WF_DATA_TEST_IDS || (exports.REPLACE_VTO_WF_DATA_TEST_IDS = {}));
